<template>
  <div v-if="modelValue" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div class="bg-white rounded-lg shadow-lg max-w-md w-full p-6 relative">
      <button class="absolute top-2 right-2 text-gray-400 hover:text-gray-700" @click="$emit('update:modelValue', false)">
        <i class="ri-close-line text-2xl"></i>
      </button>
      <slot />
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: Boolean
});
const emit = defineEmits(["update:modelValue"]);
</script>

<style scoped>
.bg-opacity-40 {
  background-color: rgba(0,0,0,0.4);
}
</style>
